import React from 'react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona si acabo de empezar?',
    a: '✅ Sí. El Tomo 3 y el Bono 1 están diseñados para instructoras desde cero.'
  }, {
    q: '¿Y si llevo años dando clases?',
    a: '✅ Especialmente para ti. Tomos 1, 2 y 6 para subir precios y escalar.'
  }, {
    q: '¿Puedo verlo en el móvil?',
    a: '✅ Sí. PDFs optimizados para móvil, tablet y ordenador.'
  }, {
    q: '¿Qué diferencia hay entre los dos packs?',
    a: '✅ El Pack Completo incluye el Sistema Profesional para Instructoras de Zumba™: todo ya creado para copiar y usar en 30 días.'
  }, {
    q: '¿Es un curso con vídeos?',
    a: '✅ No. Sistema editorial PDF. Sin plataformas ni contraseñas.'
  }];
  return <Section variant="alt" data-id="element-142">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-143">
        ❓ RESPUESTAS RÁPIDAS
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-144">
        {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-border rounded-xl p-6 shadow-card hover:shadow-violet-glow transition-all hover:border-brand-borderGlow/60" data-id="element-145">
            <h3 className="font-heading font-bold text-lg text-brand-title mb-2 tracking-wide" data-id="element-146">
              {faq.q}
            </h3>
            <p className="font-body text-brand-text" data-id="element-147">{faq.a}</p>
          </div>)}
      </div>
    </Section>;
}